<template>
	<div class="com-tab">
		<div v-for="(item,index) in tabsList" :key="index" class="com-tab-item" :class="{
		      'com-tab-active': currentTab === index,
		      'com-tab-first': index === 0, 
		      'com-tab-last': index === tabsList.length - 1
		    }" @click="tabsChange(index)">
			{{item.name}}
		</div>
	</div>
</template>

<script>
	export default {
		name: 'ComTab',
		props: {
			tabsList: {
				type: Array,
				default () {
					return [];
				}
			},
			currentTab: {
				type: Number,
				default: 0
			}
		},
		data() {
			return {

			}
		},
		methods: {
			tabsChange(index) {
				this.$emit('tabsChange', index)
			}
		},
	}
</script>

<style lang="scss" scoped>
</style>